import { Checkbox } from "@mui/material";
import { TreeViewBaseItem } from "@mui/x-tree-view-pro";
// @ts-expect-error import internals, its ok
import { RichTreeViewProApiRef } from "@mui/x-tree-view-pro/RichTreeViewPro/RichTreeViewPro.types";
import React, { FC, useCallback } from "react";
import { ExtendedTreeItemProps } from "@sinch/components/application/Rate/RateMigration/types";
import { flattenTree } from "@sinch/components/application/Rate/RateMigration/utils/tree";

type SelectAllCheckboxProps = {
  apiRef: RichTreeViewProApiRef;
  onSelectedChange: (val: { transportTripIds: string[]; jobIds: string[]; positionIds: string[] }) => void;
};
export const SelectAllCheckbox: FC<SelectAllCheckboxProps> = ({ apiRef, onSelectedChange }) => {
  const handleChange = useCallback(
    (_: unknown, checked: boolean) => {
      if (!apiRef.current) {
        return;
      }

      if (!checked) {
        onSelectedChange({ transportTripIds: [], jobIds: [], positionIds: [] });
        return;
      }

      const list = flattenTree(apiRef.current.getItemTree() as TreeViewBaseItem<ExtendedTreeItemProps>[]);

      const jobIds: string[] = [];
      const positionIds: string[] = [];
      const transportTripIds: string[] = [];

      for (const item of list) {
        if (item.selectable && item.entity.type === "Job") {
          jobIds.push(item.entity.id);
        } else if (item.entity.type === "Position") {
          positionIds.push(item.entity.id);
        } else if (item.entity.type === "TransportTrip") {
          transportTripIds.push(item.entity.id);
        }
      }

      onSelectedChange({ jobIds: jobIds, positionIds: positionIds, transportTripIds: transportTripIds });
    },
    [apiRef, onSelectedChange]
  );

  return <Checkbox data-cy="RateMigration-selectall-checkbox" onChange={handleChange} sx={{ p: 0 }} />;
};
